"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitializeApi = void 0;
const requests_1 = __importDefault(require("./requests"));
const axios_1 = __importDefault(require("axios"));
const InitializeApi = _ref => {
  let {
    serverURL,
    appAxios = axios_1.default
  } = _ref;
  return {
    deleteEntityDocument: requests_1.default.deleteEntityDocument(serverURL, appAxios),
    getCommitmentHistory: requests_1.default.getCommitmentHistory(serverURL, appAxios),
    deleteKYCDocument: requests_1.default.deleteKYCDocument(serverURL, appAxios),
    getAccreditationQuestionnaire: requests_1.default.getAccreditationQuestionnaire(serverURL, appAxios),
    getCommitmentPreview: requests_1.default.getCommitmentPreview(serverURL, appAxios),
    getDeal: requests_1.default.getDeal(serverURL, appAxios),
    getDeals: requests_1.default.getDeals(serverURL, appAxios),
    getEntities: requests_1.default.getEntities(serverURL, appAxios),
    getInvestor: requests_1.default.getInvestor(serverURL, appAxios),
    getPaymentHistories: requests_1.default.getPaymentHistories(serverURL, appAxios),
    getPortfolio: requests_1.default.getPortfolio(serverURL, appAxios),
    getQuiz: requests_1.default.getQuiz(serverURL, appAxios),
    postCommitment: requests_1.default.postCommitment(serverURL, appAxios),
    postPayment: requests_1.default.postPayment(serverURL, appAxios),
    postEntity: requests_1.default.postEntity(serverURL, appAxios),
    postEntityBankAccount: requests_1.default.postEntityBankAccount(serverURL, appAxios),
    postQuiz: requests_1.default.postQuiz(serverURL, appAxios),
    onboardInvestor: requests_1.default.onboardInvestor(serverURL, appAxios),
    reaccreditateInvestor: requests_1.default.reaccreditateInvestor(serverURL, appAxios),
    uploadEntityDocument: requests_1.default.uploadEntityDocument(serverURL, appAxios),
    uploadKYCDocument: requests_1.default.uploadKYCDocument(serverURL, appAxios),
    postSourceOfFundDescription: requests_1.default.postSourceOfFundDescription(serverURL, appAxios),
    postNPS: requests_1.default.postNPS(serverURL, appAxios),
    downloadInvestmentStatementDocument: requests_1.default.downloadInvestmentStatementDocument(serverURL, appAxios),
    downloadInvestmentStatementDocumentV2: requests_1.default.downloadInvestmentStatementDocumentV2(serverURL, appAxios),
    downloadPortfolioOverviewDocument: requests_1.default.downloadPortfolioOverviewDocument(serverURL, appAxios),
    downloadPerformanceOverviewDocument: requests_1.default.downloadPerformanceOverviewDocument(serverURL, appAxios),
    membershipCheckoutSession: requests_1.default.membershipCheckoutSession(serverURL, appAxios),
    getCommitments: requests_1.default.getCommitments(serverURL, appAxios),
    getPendingPayments: requests_1.default.getPendingPayments(serverURL, appAxios),
    getReturnCalculator: requests_1.default.getReturnCalculator(serverURL, appAxios),
    getReturnCalculatorV2: requests_1.default.getReturnCalculatorV2(serverURL, appAxios),
    generateZakatStatement: requests_1.default.generateZakatStatement(serverURL, appAxios),
    getDocuments: requests_1.default.getDocuments(serverURL, appAxios),
    signDocument: requests_1.default.signDocument(serverURL, appAxios),
    getUserBankAccounts: requests_1.default.getUserBankAccounts(serverURL, appAxios),
    postUserBankAccount: requests_1.default.postUserBankAccount(serverURL, appAxios),
    putUserBankAccount: requests_1.default.putUserBankAccount(serverURL, appAxios),
    deleteUserBankAccount: requests_1.default.deleteUserBankAccount(serverURL, appAxios),
    findLiquidationById: requests_1.default.findLiquidationById(serverURL, appAxios),
    createLiquidation: requests_1.default.createLiquidation(serverURL, appAxios),
    findWithdrawalById: requests_1.default.findWithdrawalById(serverURL, appAxios),
    getMandatoryQuestionnaire: requests_1.default.getMandatoryQuestionnaire(serverURL, appAxios),
    submitMandatoryQuestionnaire: requests_1.default.submitMandatoryQuestionnaire(serverURL, appAxios),
    findInvestmentById: requests_1.default.findInvestmentById(serverURL, appAxios),
    findDividendById: requests_1.default.findDividendById(serverURL, appAxios),
    postMarketingPreferences: requests_1.default.postMarketingPreferences(serverURL, appAxios),
    getCurrencyConversionRates: requests_1.default.getCurrencyConversionRates(serverURL, appAxios),
    getCurrencyConversionRatesV2: requests_1.default.getCurrencyConversionRatesV2(serverURL, appAxios),
    getCurrencyConversionRatesBySourceCurrency: requests_1.default.getCurrencyConversionRatesBySourceCurrency(serverURL, appAxios),
    getZakat: requests_1.default.getZakat(serverURL, appAxios),
    getNisab: requests_1.default.getNisab(serverURL, appAxios),
    updateZakat: requests_1.default.updateZakat(serverURL, appAxios),
    createZakatAsset: requests_1.default.createZakatAsset(serverURL, appAxios),
    updateZakatAsset: requests_1.default.updateZakatAsset(serverURL, appAxios),
    createZakatLiability: requests_1.default.createZakatLiability(serverURL, appAxios),
    updateZakatLiability: requests_1.default.updateZakatLiability(serverURL, appAxios),
    deleteZakatAsset: requests_1.default.deleteZakatAsset(serverURL, appAxios),
    deleteZakatLiability: requests_1.default.deleteZakatLiability(serverURL, appAxios),
    getZakatPortfolio: requests_1.default.getZakatPortfolio(serverURL, appAxios),
    createZakatPayment: requests_1.default.createZakatPayment(serverURL, appAxios)
  };
};
exports.InitializeApi = InitializeApi;
__exportStar(require("./types"), exports);
__exportStar(require("./helpers"), exports);